import { render } from "./WelcomePageView.vue?vue&type=template&id=7fe9fd5c&scoped=true&ts=true"
import script from "./WelcomePageView.vue?vue&type=script&lang=ts"
export * from "./WelcomePageView.vue?vue&type=script&lang=ts"

import "./WelcomePageView.vue?vue&type=style&index=0&id=7fe9fd5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe9fd5c"]])

export default __exports__